import GraphGroup from "../graph_group";
import { getOrSet } from "../graph_container";
import SystemDefaults from "../../../system-defaults";
import EntranceExit from "../../EntranceExit";
import COLOR_PALETTE from '../../../../editor/constants/ColorPalette.js'

class DataBase extends GraphGroup {
    constructor(graphing) {
        super();

        this._graphing = graphing;
        this._name = this.defaultName;
        this._visibility = true;

        this._color = COLOR_PALETTE ? COLOR_PALETTE[Math.floor(Math.random() * (Object.keys(COLOR_PALETTE).length))] : SystemDefaults.defaultGraphColor();

        this._animation = null;
        this._leavingAnimation = null;

        if (graphing !== null)
            this.initAnimations();
    }

    get parentLayer() { return this._graphing.parentLayer; }
    get animation() { return this._animation; }
    set animation(v) { this._animation = v; }
    get leavingAnimation() { return this._leavingAnimation; }
    set leavingAnimation(v) { this._leavingAnimation = v; }

    playLeavingAnimation() { this._enterExitCtrl.playLeave(); }
    cancelLeavingAnimation() { this._enterExitCtrl.cancelLeave(); }

    get enterExitCtrl() { return this._enterExitCtrl; }
    get isDataObject() { return true; }
    get defaultName() { return "Datapoint"; }
    get type() { throw NotImplementedException(); }

    deserialize(data) {
        this._color = "color" in data ? data.color : this._color;
        this._name = "name" in data ? data.name : this._name;
        this._visibility = "visibility" in data ? data.visibility : this._visibility;
        this.uuid = "uuid" in data ? data.uuid : this.uuid;

        const transitionAnimationData = {
            animation: "animations" in data && "entry" in data.animations ? data.animations.entry : this._animation,
            leavingAnimation: "animations" in data && "exit" in data.animations ? data.animations.exit : this._leavingAnimation
        };

        this.initAnimations(transitionAnimationData);

        return this;
    }

    initAnimations(data) {
        if (Q3.isReady) {
            this._enterExitCtrl = new EntranceExit(this, [this._dom]);
            this._enterExitCtrl.init(data);
        } else {
            Q3.Events.listen("tourReady", () => {
                this._enterExitCtrl = new EntranceExit(this, [this._dom]);
                this._enterExitCtrl.init(data);
            });
        }
    }

    toJSON() {
        return Object.assign({
            uuid: this._uuid,
            type: this.type,
            name: this._name,
            visibility: this._visibility,
            color: this._color,
            animations: {
                entry: this._animation,
                exit: this._leavingAnimation
            }
        }, this._serialize());
    }

    /**
     * @returns {this}
     */
    color() { return getOrSet.call(this, this, "_color", ...arguments); }

    _serialize() { throw NotImplementedException(); }

    /**
     * @returns {this}
     */
    name() { return getOrSet.call(this, this, "_name", ...arguments); }

    /**
     * @returns {this}
     */
    redraw() { throw NotImplementedException(); }

    /**
     * @returns {this}
     */
    visibility() { return getOrSet.call(this, this, "_visibility", ...arguments); }

    toggleVisibility() { this._visibility = !this._visibility; return this; }
}

export default DataBase;
export { DataBase };

const NotImplementedException = function () { throw new Error("Mut be implemented in inheriting class."); }
